import { render, staticRenderFns } from "./salesPricing.vue?vue&type=template&id=7a7c20f6&scoped=true&"
import script from "./salesPricing.vue?vue&type=script&lang=js&"
export * from "./salesPricing.vue?vue&type=script&lang=js&"
import style0 from "./salesPricing.vue?vue&type=style&index=0&id=7a7c20f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7c20f6",
  null
  
)

export default component.exports